import styled, { css } from 'styled-components';
import { withOmitProps } from '../helpers/elements';
import { isDefined } from '../helpers/defined';
import { overflowHiddenStyle, overflowStyle } from '../tokens/overflow';
import { userSelectNoneStyle } from '../tokens/user-select';
import { pointerEventsNoneStyle } from '../tokens/pointer-events';
import { backgroundClipStyle } from '../tokens/background';
import { height } from '../style/height';
import { width } from '../style/width';
export const imageContainerMixin = css`
  border-radius: inherit;
  box-sizing: border-box;
  ${({
  absolute,
  $absolute
}) => /* prettier-ignore */
absolute || $absolute || !isDefined(absolute ?? $absolute) ? `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    ` : `
      position: relative;
    `}
  ${({
  width: value,
  imageWidth,
  $width
}) => isDefined(imageWidth ?? value ?? $width) ? width(imageWidth ?? value ?? $width) : ''}
  ${({
  height: value,
  imageHeight,
  $height
}) => isDefined(imageHeight ?? value ?? $height) ? height(imageHeight ?? value ?? $height) : ''}
  ${({
  backgroundColor,
  $backgroundColor
}) => backgroundColor || $backgroundColor ? `background-color: ${backgroundColor || $backgroundColor};` : ''}
`;
export const imageContainerKeys = ['absolute', 'imageWidth', 'imageHeight', 'backgroundColor'];
const ImageContainer = styled.div.withConfig(withOmitProps([...imageContainerKeys]))`
  overflow: hidden;
  ${imageContainerMixin}
  ${overflowStyle}
  ${overflowHiddenStyle}
  ${userSelectNoneStyle}
  ${pointerEventsNoneStyle}
  ${backgroundClipStyle}
`;
export default ImageContainer;